module.exports = __webpack_public_path__ + "img/1.be00f762.jpg";